import React from 'react';

import styles from './KpiTags.module.scss';

interface IKpiTagsProps {
	tags: string[];
}

const KpiTags = ({ tags }: IKpiTagsProps) => (
	<div className={styles.kpiTagsContainer}>
		{tags.map((tag) => (
				<div
					key={tag}
					className={styles.kpiTag}
				>
					{tag}
				</div>
			),
		)}
	</div>
);

export default KpiTags;
